/*----------------------------------------------------------------------------*\
    Date picker link
    Trigger a date picker from a link
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */
/*global Pikaday */
/*global moment */


/*  Component
\*----------------------------------------------------------------------------*/

oy.datePickerLink = {
    init: function(){
        if (oy.cutsMustard) {
            this.initElement(document);
        }
    },

    initElement: function($context){
        var self = this;
        var $elements = $context.querySelectorAll('.js--date-link__toggle');

        for (var i = 0; i < $elements.length; ++i) {
            var $element = $elements[i];
            self.setupElement($element);
        }
    },

    setupElement: function ($element) {

        if($element.hasAttribute('href')) {
            // remove link so click doesn't interfere with date picker
            $element.removeAttribute('href');
        }

        var options = {
            field : $element.parentElement.querySelector('.js--date-link__input'),
            trigger: $element,
            format: oy.translations.dateFormat,
            i18n: oy.translations.i18n,
            yearRange: 20
        };

        if ($element.getAttribute('data-date-min')) {
            options['minDate'] = moment($element.getAttribute('data-date-min')).toDate();
        }

        if ($element.getAttribute('data-date-max')) {
            options['maxDate'] = moment($element.getAttribute('data-date-max')).toDate();
        }

        if($element.getAttribute('data-date-default')) {
            if($element.getAttribute('data-date-default')!=='') {
                options['defaultDate'] = moment($element.getAttribute('data-date-default')).toDate();
                options['setDefaultDate'] = true;
            }
        }

        if ($element.getAttribute('data-destination')) {
            options.onSelect = function(date) {
                var formatted = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate();
                if (oy.loader) {
                    oy.loader.open(document.querySelector('body'));
                }
                window.location = $element.getAttribute('data-destination') + '/' + formatted;
            };
        }

        new Pikaday(options);

    }
};


/**
 * Fire ALL the things
 */
window.addEventListener('load', function () {
    oy.datePickerLink.init();
}, false);
